import { graphql, navigate } from 'gatsby'
import * as PropTypes from 'prop-types'
import React from 'react'
import { connect } from 'react-redux'

import SeoModel from '../../datas/models/Seo'
import asTemplate from '../../root/Template'
import { getContentfulField, withTransformer } from '../../utils/GatsbyUtils'
import { chainDecorators, memoized } from '../../utils/ReactUtils'
import Seo from '../../components/Seo'
import { getTranslationFunction } from '../../utils/TranslationUtils'
import HomeContact from '../Homepage/HomeContact'

import styles from './styles'
import { SectionContainer, MarkdownText, ArrowLink } from '../../components'


const COLOR_SEED = 56080331684335

const mapSelectors = () => ({
  //
})

const mapActions = dispatch => ({
  //
})

const transformer = (data) => {
  const { contentfulLegalNoticeTemplate, contentfulLocale } = data

  if (contentfulLegalNoticeTemplate) {
    return {
      legalNoticeData: {
        title: contentfulLegalNoticeTemplate.title,
        body: getContentfulField(contentfulLegalNoticeTemplate, 'body'),
        seo: SeoModel(contentfulLegalNoticeTemplate.seo),
      },
      t: getTranslationFunction(contentfulLocale.texts)
    }
  }
}

const decorators = [
  asTemplate,
  withTransformer(transformer),
  connect(mapSelectors, mapActions),
  memoized,
]

function LegalNoticeTemplate(props) {
  const { legalNoticeData, t, locale } = props

  return (
    <>
      <Seo {...legalNoticeData.seo} />
      <div className="content">
        <SectionContainer className="container">
          <ArrowLink
            className="link"
            onClick={() => navigate(-1)}
            label={legalNoticeData.title}
            icon="/images/icons/arrow-left-white.svg"
          />
          <MarkdownText source={legalNoticeData.body} className="markdown"  />
        </SectionContainer>
      </div>
      <HomeContact
        title={t('haveAnIdea')}
        contactEmail={t('contactEmail')}
      />
      <style jsx>{styles}</style>
    </>
  )
}

LegalNoticeTemplate.propTypes = {
  legalNoticeData: PropTypes.shape({
    title: PropTypes.string,
    body: PropTypes.string,
    seo: PropTypes.object
  }),
  locale: PropTypes.string
}

LegalNoticeTemplate.defaultProps = {
  legalNoticeData: {
    title: '',
    body: '',
    seo: {}
  },
  locale: ''
}

LegalNoticeTemplate = chainDecorators(decorators, LegalNoticeTemplate)

export default LegalNoticeTemplate

export const query = graphql`
  query($langKey: String!) {
    contentfulLegalNoticeTemplate(node_locale: { eq: $langKey }) {
      ...bbsContentfulLegalNotice
    }
    allContentfulDomain(filter: { node_locale: { eq: $langKey } }) {
      edges {
        node {
          ...bbsContentfulDomain
        }
      }
    }
    contentfulLocale (node_locale: {eq: $langKey}){
      texts {
        haveAnIdea
        contactEmail
      }
    }
  }
`
